import React from 'react';

const MapScreen = () => {
    return (
        <div className="google-map-code">
            
            <iframe
                title="#6/7, Giriyappa Complex, F-38, 80 Feet Road 1st Stage, KHB Colony Basaveshwaranagar, Bengaluru-560079"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15551.123505490836!2d77.51905905541994!3d12.985862400000022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3dc069250789%3A0x735c09fe44e27e5a!2sPAVITHRA%20JEWELS!5e0!3m2!1sen!2sin!4v1742288174507!5m2!1sen!2sin"
                width="100%"
                height="450"
                frameborder="0"
                style={{ border: 0 }}
                allowfullscreen=""
                // aria-hidden="false"
                tabindex="0"
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
            >
            </iframe>
        </div>

    );
}
export default MapScreen;